import React, {useEffect, useState} from 'react'
import {Stack, Text} from '../../../vanilla'
import {ArrowContainer, Popover} from 'react-tiny-popover'
import {baseThemeContract} from '../../../vanilla/vars.css'
import {InfoIcon} from '../../../components/icons'
import {ToggleSwitch} from '../../../components/toggle-switch'
import {useBasketStore, useCustomerStore, useGlobalStore} from '../../../store/hooks/useStore'
import {observer} from 'mobx-react-lite'

interface CartSubstitutesOptionProps {
  togglerId?: string
  isBottomBorder?: boolean
}

export const CartSubstitutesOption = observer(
  ({isBottomBorder, togglerId = 'substitutes-option-toggler'}: CartSubstitutesOptionProps) => {
    const [substitutedItemsPopover, substitutedItemsPopoverSetIsOpen] = useState<boolean>(false)
    const {SubstituteToggleMemoryEnabled} = useGlobalStore().customSitePreferences
    const {updateBasketSubstitutes, excludeSubstitutes} = useBasketStore()
    const {excludeSubstitutes: customerExcludeSubstitutes} = useCustomerStore()

    const isDefaultChecked =
      excludeSubstitutes !== undefined
        ? !excludeSubstitutes
        : SubstituteToggleMemoryEnabled && !customerExcludeSubstitutes

    const [isChecked, setIsChecked] = useState<boolean>(isDefaultChecked as boolean)

    useEffect(() => {
      setIsChecked(excludeSubstitutes)
    }, [excludeSubstitutes])

    const handleToggleChange = async () => {
      updateBasketSubstitutes(!isChecked)
      setIsChecked(!isChecked)
    }

    return (
      <Stack
        direction="row"
        padding="16px"
        borderTop={['1px', '0px']}
        borderBottom={isBottomBorder ? '1px' : '0px'}
        borderColor="gray200"
        justifyContent={['center', 'flex-end']}
        alignItems="center"
        bg="white"
        gap="8px"
      >
        <Popover
          positions={['bottom']}
          align="center"
          reposition={true}
          containerStyle={{zIndex: baseThemeContract.zIndex.popover}}
          onClickOutside={() => substitutedItemsPopoverSetIsOpen(false)}
          isOpen={substitutedItemsPopover}
          content={({position, childRect, popoverRect}) => (
            <ArrowContainer
              position={position}
              childRect={childRect}
              popoverRect={popoverRect}
              arrowColor="white"
              arrowSize={10}
              arrowStyle={{zIndex: baseThemeContract.zIndex.popover}}
            >
              <Stack
                spacing="16px"
                paddingX="20px"
                paddingTop="20px"
                paddingBottom="32px"
                bg="white"
                onMouseLeave={() => substitutedItemsPopoverSetIsOpen(false)}
                style={{boxShadow: '0 10px 25px 0 rgb(0 0 0 / 40%)', maxWidth: 420}}
              >
                <Text variant="heading1" color="accent3" align="center">
                  Substituted Items
                </Text>
                <Text variant="text3" lineHeight="short" align="center">
                  We'll do our very best to deliver all the items you've ordered. If goods are out
                  of stock or otherwise unavailable we'll offer substitutes whenever we can unless
                  you've asked us not to.
                </Text>
              </Stack>
            </ArrowContainer>
          )}
        >
          <InfoIcon
            onMouseEnter={() => substitutedItemsPopoverSetIsOpen(true)}
            color="gray800"
            boxSize="16px"
          />
        </Popover>
        <ToggleSwitch
          type="checkbox"
          name="receiveSubstitutedItems"
          checked={isChecked}
          value="Receive substituted items"
          labelText="I'm happy to receive substituted items"
          id={togglerId}
          labelVariant="text2"
          justifyContent="space-between"
          onChange={handleToggleChange}
        />
      </Stack>
    )
  }
)
